import { BaseDatapoint } from '@/sections/Workspace/Metrics/types';

enum EntityType {
  Chain = 'CHAIN',
  ChainDeployment = 'CHAIN_DEPLOYMENT',
  Chainlet = 'CHAINLET',
  Oracle = 'ORACLE',
  OracleVersion = 'ORACLE_VERSION',
}

// NOTE(Tyron): We use a separate enum since Training
// projects/jobs are shown in a separate billing tab.
enum TrainingEntityType {
  TrainingProject = 'TRAINING_PROJECT',
  TrainingJob = 'TRAINING_JOB',
}

enum UsageType {
  Deployments = 'DEPLOYMENTS',
  SharedEndpoints = 'SHARED_ENDPOINTS',
  Training = 'TRAINING',
}

type UsageItem = {
  // Needed for rendering filter options and table.
  path: string[];

  // Needed for usage and cost columns.
  time: number;
  total: number;
  requests: number;

  // Needed for name column.
  deleted: boolean;
  type: EntityType;
  name: string;
  id: string;
};

type SelectedUsageItem = {
  path: string[];
  deleted: boolean;
  type: EntityType;
  name: string;
  id: string;
};

type OrgSharedEndpointFuseDoc = {
  id: string;
  name: string;
};

type TrainingEntityFuseDoc =
  | {
      type: TrainingEntityType.TrainingProject;
      name: string;
      id: string;
    }
  | {
      type: TrainingEntityType.TrainingJob;
      projectId: string;
      name: string;
      id: string;
    };

type SelectedTrainingEntity = TrainingEntityFuseDoc;

type TrainingUsageItem = TrainingEntityFuseDoc & {
  path: string[];

  minutes: number;
  cost: number;
};

interface UsageChartDatapoint extends BaseDatapoint {
  cost: number;
  requests: number;
  minutes: number;
}

interface SharedEndpointsUsageChartDatapoint extends BaseDatapoint {
  cost: number;
}

type TrainingUsageChartDatapoint = BaseDatapoint & {
  minutes: number;
  cost: number;
};

type ChartData = {
  costDatapoints: number[];
  requestsDatapoints: number[];
  labels: string[];
  tooltipData: UsageChartDatapoint[];
};

export {
  UsageType,
  SelectedUsageItem,
  UsageItem,
  UsageChartDatapoint,
  ChartData,
  EntityType,
  TrainingEntityType,
  SharedEndpointsUsageChartDatapoint,
  OrgSharedEndpointFuseDoc,
  TrainingEntityFuseDoc,
  TrainingUsageItem,
  SelectedTrainingEntity,
  TrainingUsageChartDatapoint,
};
